module.exports = __webpack_public_path__ + "img/sgae.3b6715b4.png";